import { createAction, props } from '@ngrx/store';
import { ColumnAlias } from './interfaces/column-alias.interface';

export const COLUMNS_ALIASES_FEATURE_NAME = 'columns-aliases';

export const setColumnsAliases = createAction(
  `[${COLUMNS_ALIASES_FEATURE_NAME}] Set columns aliases`,
  props<{ columnsAliases: ColumnAlias[] }>(),
);

export const getColumnsAliases = createAction(
  `[${COLUMNS_ALIASES_FEATURE_NAME}] Get columns aliases`,
);

export const getColumnsAliasesSuccess = createAction(
  `[${COLUMNS_ALIASES_FEATURE_NAME}] Get columns aliases success`,
  props<{ columnsAliases: ColumnAlias[] }>(),
);

export const getColumnsAliasesFailure = createAction(
  `[${COLUMNS_ALIASES_FEATURE_NAME}] Get columns aliases failure`,
);

export const createAlias = createAction(
  `[${COLUMNS_ALIASES_FEATURE_NAME}] Create alias`,
  props<{ attribute: string, alias: string, }>(),
);

export const createAliasSuccess = createAction(
  `[${COLUMNS_ALIASES_FEATURE_NAME}] Create alias success`,
);

export const deleteAlias = createAction(
  `[${COLUMNS_ALIASES_FEATURE_NAME}] Delete alias`,
  props<{ id: string }>(),
);

export const deleteAliasSuccess = createAction(
  `[${COLUMNS_ALIASES_FEATURE_NAME}] Delete alias success`,
);

export const editAlias = createAction(
  `[${COLUMNS_ALIASES_FEATURE_NAME}] Edit alias`,
  props<{ id: string, alias: string, attribute: string }>(),
);
export const editAliasSuccess = createAction(
  `[${COLUMNS_ALIASES_FEATURE_NAME}] Edit alias success`,
  props<{ id: string, alias: string, attribute: string }>(),
);

export const editAliasFailure = createAction(
  `[${COLUMNS_ALIASES_FEATURE_NAME}] Edit alias failure`,
);

export const toggleEditMode = createAction(
  `[${COLUMNS_ALIASES_FEATURE_NAME}] Set up edit mode for alias`,
  props<{ id: string }>(),
);

export const initCreateMode = createAction(
  `[${COLUMNS_ALIASES_FEATURE_NAME}] Init create mode for columns aliases`,
);

export const removeCreateMode = createAction(
  `[${COLUMNS_ALIASES_FEATURE_NAME}] Remove create mode for columns aliases`,
);

export const clearStore = createAction(
  `[${COLUMNS_ALIASES_FEATURE_NAME}] Clear store`,
);
